const arrayBufferToJSON = buffer => {
  const stringDecoded = new TextDecoder().decode(new Uint8Array(buffer))
  return JSON.parse(stringDecoded)
}

export default arrayBufferToJSON
